import reloj from '../assets/reloj.png';
import calendario from '../assets/calendario.png';
import bebidasCalientes from '../assets/bebidasCalientes.png';
import bebidasFrias from '../assets/bebidasFrias.png';
import complementos from '../assets/complementos.png';
import hamburguesas from '../assets/hamburguesas.png';
import informacion from '../assets/i.png';
import eliminar from '../assets/eliminar.png';
// eslint-disable-next-line
export default {
  reloj,
  calendario,
  bebidasCalientes,
  bebidasFrias,
  complementos,
  hamburguesas,
  informacion,
  eliminar,
};
